import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.visitors;

const getProfileVisitors = createSelector(getData, visitors => visitors);

export default getProfileVisitors;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getProfileVisitors.js